import { createSchemaSelectors } from 'ngrx-normalizr';

import { AnxietyQuiz, anxietyQuizSchema } from '../schemas/anxiety-quiz.schema';

const anxietyQuizSchemaSelectors = createSchemaSelectors<AnxietyQuiz>(anxietyQuizSchema);

export const getAnxietyQuizzes = anxietyQuizSchemaSelectors.getEntities;
